require("react").PropTypes = require("prop-types");
require("react").createClass = require("create-react-class");
